<template>
    <div>
        <!-- Modal -->
        <div id="sendForSigning" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="!tempProposal.sent_for_signing_at" class="modal-title text-lg">Send to Client</h4>
                        <h4 v-else class="modal-title text-lg">Resend to Client</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Emails</label>
                            <multiselect v-model="sendForSigningForm.emails"
                                         tag-placeholder="Press enter to add"
                                         placeholder="Add an email to send for signing" label="email" track-by="email"
                                         :options="options" :multiple="true" :taggable="true"
                                         :close-on-select="true"
                                         @tag="addEmailForSigning">
                            </multiselect>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="copy-signing-link"
                                name="copy-signing-link"
                                @click.prevent="checkSigningFields('copy')"
                                class="btn btn-outline-primary rounded-full btn-sm"
                                :disabled="(sendForSigningForm.emails.length<=0)"
                                title="Add signer email & click the button to copy link"
                        >
                            Copy Signing Link
                        </button>
                        <button id="send-for-viewing"
                                name="send-for-viewing"
                                @click.prevent="sendForViewing"
                                class="btn btn-outline-primary rounded-full btn-sm">
                            Send to Client
                        </button>
                        <button v-if="!tempProposal.sent_for_signing_at" id="send-for-signing"
                                name="send-for-signing"
                                @click.prevent="checkSigningFields('sign')"
                                class="btn btn-outline-primary rounded-full btn-sm">
                            Send to Client for Signing
                        </button>
                        <button v-else id="resend-for-signing" name="resend-for-signing"
                                @click.prevent="checkSigningFields('sign')"
                                class="btn btn-outline-primary rounded-full btn-sm">
                            Resend to Client for Signing
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!tempProposal.locked && tempProposal.sent_for_signing_at && !tempProposal.signed_at"
             class="bg-red-lightest border-1 border-red-lighter mb-2 px-2 py-1 rounded text-red">
                            <span class="text-sm">The proposal has been sent and unlocked again for editing.
                                </span>
        </div>
        <div v-if="pgIssueMessage" class="alert alert-danger alert-dismissible w-50 m-auto py-2">
            <button type="button" class="close py-2" @click="() => {pgIssueMessage = null;}" data-dismiss="alert">&times;</button>
            {{ pgIssueMessage }}
        </div>

        <div :class="(pgIssueMessage)? 'col-12 mb-3 p-0 mt-3':'col-12 mb-3 p-0'" id="proposalTopToolBar">
            <div class="col-12 p-0">
                <div class="inline-block" style="top: -3px !important; position: relative;">
                    <a class="proposal-back-btn" title="Back to project" :href="`/project/${proposal.project_id}/edit`">
                        <
                    </a>
                </div>
                <div class="inline-block ml-2" style="width: 46%;background: white;padding: 5px 10px 0 10px;border-radius: 50px;">
                    <div class="flex items-baseline">
                        <div v-if="!editName" @click="editName = true" class="text-2xl text-grey-darker mr-2 project-title" style="width: 100%;float: left;" :title="tempProjectName">
                            Project:  {{ tempProjectName }}
                        </div>
                        <input v-else v-model="tempProjectName" @blur="saveProjectName" class="mr-2 form-control projectNameField w-100" style="color:#333;">
                    </div>
                </div>

                <div class="inline-block ml-4" style="position: inherit; top: -15px !important;">
                    <div v-if="tempProposal.signed_at"
                         class="bg-green-lightest border-1 border-green-lighter mb-2 px-2 py-1 rounded text-green">
<!--                            <span class="text-sm">-->
<!--                                Signed by {{ (tempProposal.signed_by)? (tempProposal.signed_by.email_at_signing)? tempProposal.signed_by.email_at_signing:tempProposal.signed_by.email:'' }} on {{ tempProposal.signed_at }} {{(tempProposal.signed_time)? 'at '+tempProposal.signed_time:''}}-->
<!--                            </span>-->
                            <span class="text-sm">
                                Proposal signed and completed on {{ tempProposal.signed_at }} {{(tempProposal.signed_time)? 'at '+tempProposal.signed_time:''}}
                            </span>
                    </div>

                </div>
                <div class="inline-block float-right pt-1">
                    <button v-if="!tempProposal.signed_at" @click="deleteProposal"
                            class="btn btn-outline-danger rounded-full mr-2">
                        Delete Proposal
                    </button>

                    <button v-if="!tempProposal.signed_at && tempProposal.selected_proposal_type" @click="downloadProposalPDF"
                            class="btn btn-outline-primary rounded-full mr-2">
                        Download PDF
                    </button>

<!--                    <button v-if="!tempProposal.signed_at && tempProposal.selected_proposal_type" @click="generateProposalDocument"-->
<!--                            class="btn btn-outline-primary rounded-full mr-2">-->
<!--                        Download Document-->
<!--                    </button>-->
                    <button v-if="!tempProposal.locked && !tempProposal.signed_at && tempProposal.selected_proposal_type" @click="copyProposal"
                            class="btn btn-outline-primary rounded-full mr-2">
                        Copy Proposal
                    </button>
                    <button v-if="tempProposal.locked && !tempProposal.signed_at && tempProposal.selected_proposal_type" @click="unlock"
                            class="btn btn-outline-danger rounded-full">
                        Unlock
                    </button>
                    <button
                        v-if="!tempProposal.locked && tempProposal.sent_for_signing_at && !tempProposal.signed_at && tempProposal.selected_proposal_type"
                        @click="lock"
                        class="btn btn-outline-danger rounded-full">
                        Lock
                    </button>
                    <span v-if="tempProposal.selected_proposal_type">
                        <button v-if="!showReviewButton" @click="generateReview" class="btn btn-outline-primary rounded-full mr-2">
                            Generate Review
                        </button>
                        <button v-else @click="review" class="btn btn-outline-primary rounded-full mr-2">
                            Review
                        </button>
                    </span>
                    <button v-if="!tempProposal.signed_at && tempProposal.selected_proposal_type" @click="openSendForSigningModal"
                            class="btn btn-outline-primary rounded-full">
                        <span v-if="!tempProposal.sent_for_signing_at"><i v-if="showSendLoader" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Send to Client</span>
                        <span v-else><i v-if="showSendLoader" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Resend to Client</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="flex">
            <div class="col-2 bg-white shadow" style="padding: 0">
                <div>
                    <div class="text-lg bg-primary border-b-2 border-followup-nav px-3 py-3 text-white text-center">
                        Select Template <b-dropdown id="proposal-template-settings-dropdown" dropright :text="selectedProposalTypeName" variant="outline-danger" class="proposal-template-settings-dropdown mt-2" :disabled="(proposal.signed_at)? true:false">
                        <span v-if="proposalTypes.length > 0">
                            <b-dropdown-item @click="deselectProposalType()"><span class="proposal-type-name-span deselect-proposal-type-name-span">Deselect Proposal Template</span></b-dropdown-item>
                            <span :class="{'proposal-type-head-span' : (listProposalType.default_type !== 1)}" v-for="listProposalType in proposalTypes">
                                <b-dropdown-item @click="selectProposalType(listProposalType)" v-if="(listProposalType.default_type !== 1)">
                                <span class="proposal-type-name-span">{{listProposalType.name}}</span>
                                </b-dropdown-item>
                                <button v-if="(listProposalType.default_type !== 1)" type="button" data-toggle="dropdown" aria-haspopup="true" @click.prevent=""
                                        aria-expanded="false">
                                    <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                         viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        <path
                                            d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        <path
                                            d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                    </svg>
                                </button>
                                <div v-if="(listProposalType.default_type !== 1)" class="dropdown-menu">
                                    <a class="dropdown-item" @click="makeCurrentProposalDefaultProposalType(listProposalType.id)">Make Default Type</a>
                                </div>
                            </span>
                        </span>
                        <span v-else>
                            <b-dropdown-item class="dropdownCustomItem">No proposal has been created yet.</b-dropdown-item>
                        </span>
                    </b-dropdown>
                    </div>
                </div>
                <div class="card-body" v-if="tempProposal.selected_proposal_type">
                    <draggable v-model="tempProposal.sections" v-if="proposalCoverPageOptions.all_cover == 0">
                        <transition-group>
                            <div v-for="(section, index) in tempProposal.sections" :key="section.uniqueIdentifier"
                                 @click="handler(section,index)"
                                 :class="{
                                    'border-followup-nav' : (currentlySelectedSection.id === section.id && currentlySelectedSection.tag === section.tag),
                                    // 'border-blue-lightest bg-blue-lightest' : this.selectedTemplateObject.forEach(item => {if(item.section_id == data.section_id && item.type == data.type){true}}),
                                    'section-turned-off': (!section.include_in_report),
                                    'section-turned-off-active' : (currentlySelectedSection.id === section.id && currentlySelectedSection.tag === section.tag && !section.include_in_report),
                                 }"
                                 class="flex justify-between border-2 p-2 rounded mb-1 text-grey-darker tracking-wide cursor-pointer hover:border-followup-nav border-grey-lighter bg-grey-lighter"
                                 :id="section.type+section.id" v-if="section.tag == 'title'">

                                <div class="flex flex-col mr-15">
                                    <div class="flex items-baseline">
                                        <div v-show="currentEditSectionName != index" class="section-name-div" :title="section.name">{{ section.name }}</div>
                                        <input v-if="currentEditSectionName == index" v-model="section.name"
                                               class="mr-2 form-control">
                                        <a v-if="currentEditSectionName == index" href="#"
                                           @click="saveSectionName(section, section.name)">Save</a>
                                    </div>
                                </div>

                                <div class="dropdown open">
                                    <button v-if="section.tag !== 'title'" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                             viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        </svg>
                                    </button>

                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click="editSectionName(index)">Rename</a>
                                        <a  @click="duplicateSection(section)" class="dropdown-item"
                                           href="#">Duplicate</a>
                                        <a @click="handleIncludeInReportChange(section)"
                                           v-model="section.include_in_report" class="dropdown-item" href="#">
                                            <span v-if="section.include_in_report">Turn Off</span>
                                            <span v-else>Turn On</span>
                                        </a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'text')">Text Page</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'pdf')">PDF Upload</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'sheet')">Excel Sheet</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'photo')">Photo Page</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'quote')">Quote Page</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.mark_standard == 0" class="dropdown-item" @click="markCustomSection(section.id, 1)">Standard Section</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.mark_standard == 1" class="dropdown-item" @click="markCustomSection(section.id, 0)">Remove Standard Section</a>
                                        <a v-if="section.enable_delete" class="dropdown-item" href="#"
                                           @click="deleteSection(section)">Delete</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.proposal_template_group_id == null && !section.type_quote" class="dropdown-item" @click="assignProposalTemplateGroup()">Assign Section Content</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.proposal_template_group_id != null && !section.type_quote" class="dropdown-item" @click="assignProposalTemplateGroup()">Change Assigned Section Content</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.proposal_template_group_id != null && !section.type_quote" class="dropdown-item" @click="unassignProposalTemplateGroup(section)">Unassign Section Content</a>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                    <draggable v-model="tempProposal.sections" @change="handleSectionOrderChange">
                        <transition-group>
                            <div v-for="(section, index) in tempProposal.sections" :key="section.uniqueIdentifier"
                                 @click="handler(section,index)"
                                 :class="{
                                    'border-followup-nav' : (currentlySelectedSection.id === section.id && currentlySelectedSection.tag === section.tag),
                                    // 'border-blue-lightest bg-blue-lightest' : this.selectedTemplateObject.forEach(item => {if(item.section_id == data.section_id && item.type == data.type){true}}),
                                    'section-turned-off': (!section.include_in_report),
                                    'section-turned-off-active' : (currentlySelectedSection.id === section.id && currentlySelectedSection.tag === section.tag && !section.include_in_report),
                                 }"
                                 class="flex justify-between border-2 p-2 rounded mb-1 text-grey-darker tracking-wide cursor-pointer hover:border-followup-nav border-grey-lighter bg-grey-lighter"
                            :id="section.type+section.id" v-if="section.tag !== 'title'">

                                <div class="flex flex-col mr-15">
                                    <div class="flex items-baseline">
                                        <div v-show="currentEditSectionName != index" class="section-name-div" :title="section.name">{{ section.name }}</div>
                                        <input v-if="currentEditSectionName == index" v-model="section.name"
                                               class="mr-2 form-control">
                                        <a v-if="currentEditSectionName == index" href="#"
                                           @click="saveSectionName(section, section.name)">Save</a>
                                    </div>
                                </div>

                                <div class="dropdown open">
                                    <button v-if="section.tag !== 'title'" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                             viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        </svg>
                                    </button>

                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click="editSectionName(index)">Rename</a>
                                        <a @click="duplicateSection(section)" class="dropdown-item"
                                           href="#">Duplicate</a>
                                        <a @click="handleIncludeInReportChange(section)"
                                           v-model="section.include_in_report" class="dropdown-item" href="#">
                                            <span v-if="section.include_in_report">Turn Off</span>
                                            <span v-else>Turn On</span>
                                        </a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'text')">Text Page</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'pdf')">PDF Upload</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'sheet')">Excel Sheet</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'photo')">Photo Page</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions'" class="dropdown-item" @click="customSectionType(section.id, 'quote')">Quote Page</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.mark_standard == 0" class="dropdown-item" @click="markCustomSection(section.id, 1)">Standard Section</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.mark_standard == 1" class="dropdown-item" @click="markCustomSection(section.id, 0)">Remove Standard Section</a>
                                        <a v-if="section.enable_delete" class="dropdown-item" href="#"
                                           @click="deleteSection(section)">Delete</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.proposal_template_group_id == null && !section.type_quote" class="dropdown-item" @click="assignProposalTemplateGroup()">Assign Section Content</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.proposal_template_group_id != null && !section.type_quote" class="dropdown-item" @click="assignProposalTemplateGroup()">Change Assigned Section Content</a>
                                        <a v-if="section.tag !== 'title' && section.tag !== 'introduction' && section.tag !== 'terms-and-conditions' && section.proposal_template_group_id != null && !section.type_quote" class="dropdown-item" @click="unassignProposalTemplateGroup(section)">Unassign Section Content</a>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                    <div class="flex justify-center w-full">
                        <button @click="addCustomSection" id="add-custom-section-button" class="btn btn-outline-secondary rounded-large flex w-full">
                            <span class="material-icons mr-2">add</span>
                            Add Custom Section
                        </button>
                    </div>
                </div>
            </div>

            <div class=" p-0">
                <proposal-generator-section :key="currentlySelectedSection.uniqueIdentifier"
                                            @deleteSection="deleteSection"
                                            @titleChanged="titleChanged"
                                            @customSectionChanged="customSectionChanged"
                                            @introductionChanged="introductionChanged"
                                            @termsAndConditionsChanged="termsAndConditionsChanged"
                                            :section="currentlySelectedSection"
                                            :proposal="proposal"
                                            :team="team"
                                            :selected-resource-file="this.selectedResourceFile"
                                            :role="role"
                                            :select-cover-page-template="selectCoverPageTemplate"
                                            :selected-template-object="selectedTemplateObject"
                                            :temp-proposal="tempProposal"
                                            :proposal-cover-options="proposalCoverPageOptions"
                                            ref="ProposalSectionSelectionRef"
                                            :user="user"
                                            :active-team-users="activeTeamUsers"
                                            :masks="masks"
                                            :symbols="symbols"
                                            :exchange="exchange"
                                            :externalEmailService="externalEmailService"
                                            :project="project"
                                            :selected-proposal-type="selectedProposalType"
                                            :formatted-sales-taxes-for-quote="formattedSalesTax"
                                            :quote-comment-templates="quoteCommentTemplates"
                ></proposal-generator-section>
            </div>
        </div>
        <div class="proposal-overlay">
            <img :src="proposal.proposal_loader" />
            <img class="pg-loader" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/pg-loader.gif" />
        </div>
        <div class="proposal-overlay-document">
            <img :src="proposal.proposal_loader" />
            <h1 class="align-center">Generating proposal document, please wait.</h1>
        </div>
        <div class="proposal-overlay-document proposal-overlay-applying-template">
            <img :src="proposal.proposal_loader" />
            <h1 class="align-center">Applying template.</h1>
        </div>
        <div class="proposal-overlay-document proposal-overlay-creating-copy">
            <img :src="proposal.proposal_loader" />
            <h1 class="align-center">Creating proposal copy.</h1>
        </div>
        <div class="proposal-overlay-document proposal-overlay-creating-copy proposal-check-signing-field">
            <img :src="proposal.proposal_loader" />
            <h1 class="align-center">Checking for signing fields</h1>
        </div>
        <proposal-signer
            v-if="signerOptions.length > 0"
            ref="ProposalSigner"
            :signer-options="signerOptions"
            :proposal-id="proposal.id"
        ></proposal-signer>
        <div id="sendForCustomSigner" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="!tempProposal.sent_for_signing_at" class="modal-title text-lg">Send to Client</h4>
                        <h4 v-else class="modal-title text-lg">Resend to Client</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        Drag to arrange signers sequence.
                        <div class="form-group">
                            <draggable v-model="customSigns" @change="handleSignOrderChange">
                                <transition-group>
                                    <div v-for="(sign, index) in customSigns" :key="sign.key"
                                         @click="handlerSign(sign,index)" class="bg-white px-2 py-1 my-1 rounded border-1 cursor-move"
                                         :id="'sign-'+sign.key">
                                        {{sign.name}} - {{sign.email}}
                                    </div>
                                </transition-group>
                            </draggable>
                        </div>
                    </div>
                    <div class="modal-footer">
<!--                        <button id="copy-signing-link"-->
<!--                                name="copy-signing-link"-->
<!--                                @click.prevent="checkSigningFields('copy')"-->
<!--                                class="btn btn-outline-primary rounded-full btn-sm"-->
<!--                                :disabled="(sendForSigningForm.emails.length<=0)"-->
<!--                                title="Add signer email & click the button to copy link"-->
<!--                        >-->
<!--                            Copy Signing Link-->
<!--                        </button>-->
                        <button id="send-for-viewing"
                                name="send-for-viewing"
                                @click.prevent="sendForViewing"
                                class="btn btn-outline-primary rounded-full btn-sm">
                            Send to Client
                        </button>
                        <button v-if="!tempProposal.sent_for_signing_at" id="send-for-signing"
                                name="send-for-signing"
                                @click.prevent="checkSigningFields('sign')"
                                class="btn btn-outline-primary rounded-full btn-sm">
                            Send to Client for Signing
                        </button>
                        <button v-else id="resend-for-signing" name="resend-for-signing"
                                @click.prevent="checkSigningFields('sign')"
                                class="btn btn-outline-primary rounded-full btn-sm">
                            Resend to Client for Signing
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable                      from 'vuedraggable';
    import Form                           from "../../utils/form";
    import Multiselect                    from 'vue-multiselect';
    import Swal                           from 'sweetalert2';
    import Swatches                       from 'vue-swatches'
    import "vue-swatches/dist/vue-swatches.min.css"
    import vueFilePond                    from 'vue-filepond';
    import 'filepond/dist/filepond.min.css';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import axios                          from "axios";
    import ProjectContactModal from "../project/external-email/project-contact-modal.vue";
    import ProposalSigner from "./proposal-signer.vue";

    let token      = document.head.querySelector('meta[name="csrf-token"]');
    const FilePond = vueFilePond(FilePondPluginFileValidateType);

    export default {
        props     : ['proposal', 'team', 'role', 'proposalTypes', 'proposalCoverOptions', 'user', 'activeTeamUsers', 'masks', 'symbols', 'exchange', 'externalEmailService', 'project'],
        components: {ProposalSigner, ProjectContactModal, draggable, Multiselect, Swatches, FilePond},
        data() {
            return {
                imageHeader                  : false,
                imageFooter                  : false,
                editName                     : false,
                currentEditSectionName       : -1,
                tempProposal                 : {
                    id                 : this.proposal.id,
                    name               : this.proposal.name,
                    sections           : Object.values(this.proposal.sections),
                    sent_for_signing_at: this.proposal.sent_for_signing_at,
                    locked             : this.proposal.locked,
                    signed_at          : this.proposal.signed_at,
                    signed_time        : (this.proposal.signed_time)? moment.utc(this.proposal.signed_at_date+' '+this.proposal.signed_time).local().format('hh:mm A'):'',
                    signed_by          : this.proposal.signed_by,
                    color              : this.proposal.color,
                    selected_proposal_type : this.proposal.selected_proposal_type
                },
                currentlySelectedSection     : null,
                currentlySelectedSectionIndex: 0,
                introductionForm             : (this.proposal.sections.introduction)? new Form({
                    id               : this.proposal.sections.introduction.id,
                    proposal_id      : this.proposal.sections.introduction.proposal_id,
                    name             : this.proposal.sections.introduction.name,
                    include_in_report: this.proposal.sections.introduction.include_in_report,
                    order            : this.proposal.sections.introduction.order,
                    tag              : this.proposal.sections.introduction.tag,
                    text             : this.proposal.sections.introduction.text,
                    signature_section: this.proposal.sections.introduction.signature_section,
                    proposal_template_id: this.proposal.sections.introduction.proposal_template_id,
                }) : '',
                titleForm                    : new Form({
                    id               : this.proposal.sections.title.id,
                    proposal_id      : this.proposal.sections.title.proposal_id,
                    name             : this.proposal.sections.title.name,
                    include_in_report: this.proposal.sections.title.include_in_report,
                    order            : this.proposal.sections.title.order,
                    tag              : this.proposal.sections.title.tag,
                    project          : this.project,
                    company          : this.company,
                    companyContact   : this.companyContact,
                    projectContact   : this.projectContact,
                    createdBy        : this.createdBy,
                    url              : this.proposal.sections.title.url,
                    path             : this.proposal.sections.title.path,
                    token            : this.proposal.sections.title.token,
                    template         : this.proposal.sections.title.template,
                    signature_section: this.proposal.sections.title.signature_section,
                }),
                // inspectionForm               : new Form({
                    // id               : this.proposal.sections.inspection.id,
                    // proposal_id      : this.proposal.sections.inspection.proposal_id,
                    // name             : this.proposal.sections.inspection.name,
                    // include_in_report: this.proposal.sections.inspection.include_in_report,
                    // order            : this.proposal.sections.inspection.order,
                    // tag              : this.proposal.sections.inspection.tag,
                    // sections         : this.proposal.sections.inspection.sections,
                    // signature_section: this.proposal.sections.inspection.signature_section,
                    // proposal_template_id: this.proposal.sections.inspection.proposal_template_id,
                // }),
                // quoteDetailsForm: new Form({
                //     id: this.proposal.sections.quoteDetails.id,
                //     proposal_id: this.proposal.sections.quoteDetails.proposal_id,
                //     name: this.proposal.sections.quoteDetails.name,
                //     include_in_report: this.proposal.sections.quoteDetails.include_in_report,
                //     order: this.proposal.sections.quoteDetails.order,
                //     tag: this.proposal.sections.quoteDetails.tag,
                //     notes: this.proposal.sections.quoteDetails.notes,
                //     sections: this.proposal.sections.quoteDetails.sections,
                // }),
                // authorizationForm: new Form({
                //     id: this.proposal.sections.authorization.id,
                //     proposal_id: this.proposal.sections.authorization.proposal_id,
                //     name: this.proposal.sections.authorization.name,
                //     include_in_report: this.proposal.sections.authorization.include_in_report,
                //     order: this.proposal.sections.authorization.order,
                //     tag: this.proposal.sections.authorization.tag,
                //     disclaimer: this.proposal.sections.authorization.disclaimer,
                //     section: this.proposal.sections.authorization.section,
                //     product_and_selections: this.proposal.sections.authorization.product_and_selections,
                //     footer_notes: this.proposal.sections.authorization.footer_notes,
                // }),
                termsAndConditionsForm       : (this.proposal.sections.termsAndConditions)? new Form({
                    id               : this.proposal.sections.termsAndConditions.id,
                    proposal_id      : this.proposal.sections.termsAndConditions.proposal_id,
                    name             : this.proposal.sections.termsAndConditions.name,
                    include_in_report: this.proposal.sections.termsAndConditions.include_in_report,
                    order            : this.proposal.sections.termsAndConditions.order,
                    tag              : this.proposal.sections.termsAndConditions.tag,
                    text             : this.proposal.sections.termsAndConditions.text,
                    signature_section: this.proposal.sections.termsAndConditions.signature_section,
                    proposal_template_id: this.proposal.sections.termsAndConditions.proposal_template_id,
                }) : '',
                customSectionForm            : new Form({
                    id                   : null,
                    proposal_id          : null,
                    name                 : null,
                    include_in_report    : null,
                    order                : null,
                    tag                  : null,
                    text                 : null,
                    token                : null,
                    url                  : null,
                    type_text            : null,
                    type_authorization   : null,
                    type_pdf             : null,
                    type_sheet           : null,
                    type_quote           : null,
                    section_authorization: null,
                    signature_section    : false,
                    proposal_template_id : null,
                    type_photo           : null,
                    photo_page_id        : null,
                    photo_page_data      : null,
                    photo_page_url       : null,
                }),
                options                      : [],
                sendForSigningForm           : new Form({
                    emails: [],
                }),
                signature                    : false,
                applyTemplateButton          : false,
                templateOptions              : false,
                isTemplateApplied            : false,
                selectedTemplateId           : null,
                selectedTemplate             : null,
                allTemplates                 : [],
                server                       : {
                    process: (fieldName, file, metadata, load, error, progress) => {
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        formData.append('type', fieldName);

                        const request = new XMLHttpRequest();

                        request.open('POST', '/proposal/' + this.proposal.id + '/proposal-generator/upload-file');
                        request.setRequestHeader('X-CSRF-TOKEN', token.content);

                        request.upload.onprogress = (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload            = function () {
                            if (request.status >= 200 && request.status < 300) {
                                let response     = JSON.parse(request.response);
                                this.imageHeader = response.proposal.header_image_url;
                                load(request.responseText);
                            } else {
                                error('oh no');
                            }
                        };
                        request.send(formData);
                        setTimeout(() => {
                            window.location.reload(true);
                        }, 2000);
                    }
                },
                resourceImages : this.proposal.resource_images,
                selectedResourceFile:(this.proposal.selected_resource_file)? this.proposal.selected_resource_file.url:'',
                tempProjectName:this.proposal.project_name,
                selectCoverPageTemplate:0,
                selectedTemplateObject:[],
                addedInSelectedTemplateObject:true,
                showReviewButton:(this.proposal.pdf_path)? true:false,
                selectedProposalTypeName:'Proposal Templates',
                tempProposalTypeSections:[],
                toastMessage: true,
                proposalCoverPageOptions:(this.proposalCoverOptions)? this.proposalCoverOptions:{all_cover:0},
                prizmEditorBaseURL:null,
                sectionSaveStatus:[],
                senderIp: null,
                proposalData: this.proposal,
                signerOptions: [],
                userSelection: null,
                pgIssueMessage: null,
                selectedProposalType: null,
                formattedSalesTax: null,
                quoteCommentTemplates: [],
                customSigns: [],
                showSendLoader: false,
            }
        },
        created() {
            $(() => $('[data-toggle="tooltip"]').tooltip());
            if(this.proposalCoverPageOptions.all_cover == 1){
                this.currentlySelectedSection = this.tempProposal.sections[1];
            }else{
                this.currentlySelectedSection = this.tempProposal.sections[0];
            }

            const emailOption             = {
                email: (this.proposal.contact_person_info)? (this.proposal.contact_person_info.email)? this.proposal.contact_person_info.email:'':'',
            };
            this.options.push(emailOption);
            this.imageHeader = this.proposal.header_image_url ?? false;
            this.imageFooter = this.proposal.footer_image_url ?? false;
            this.toastMessage = false;
        },
        mounted() {
            Bus.$on('signature', data => {
                this.signature = data;
            });

            Bus.$on('showButton', data => {
                this.templateOptions = false;
                this.applyTemplateButton = false;
                this.isTemplateApplied = false;
                this.selectedTemplateId = null;

                switch (data.button) {
                    case 'template':
                        this.templateOptions = true;
                        if(data.proposal_template_id){
                            this.isTemplateApplied = true;
                            this.applyTemplateButton = true;
                            this.selectedTemplateId = data.proposal_template_id;
                        }
                        break;

                    case 'hideTemplate':
                        this.templateOptions = false;
                        this.applyTemplateButton = false;
                        this.isTemplateApplied = false;
                        break;

                    case 'hideSaveTemplate':
                        this.templateOptions = false;
                        this.applyTemplateButton = false;
                        this.isTemplateApplied = false;
                        break;
                }
            });

            Bus.$on('allTemplates', data => {
                this.selectedTemplate = null;
                if (this.isTemplateApplied) {
                    this.selectedTemplate = data.value.find(template => template.id === this.selectedTemplateId);
                }

                this.allTemplates = data.value ? (data.value.length ? data.value : []) : [];

                this.tempProposal.sections.forEach((section, index) => {
                    if(section.tag == data.type){
                        this.tempProposal.sections[index].all_templates = data.value;
                        if(data.selectedTemplateValue){
                            this.tempProposal.sections[index].proposal_template_id = data.selectedTemplateValue;
                        }
                    }else if(section.type == data.type) {
                        this.tempProposal.sections[index].all_templates = data.value;
                        if(data.selectedTemplateValue){
                            this.tempProposal.sections[index].proposal_template_id = data.selectedTemplateValue;
                        }
                    }
                });

                if(data.proposal != null) {
                    this.initTempProposal(data.proposal)
                }

            });

            Bus.$on('selectedResourceFile', data => {
                this.selectedResourceFile = data;
            });

            Bus.$on('selectCoverPageTemplateParent', data => {
                this.selectCoverPageTemplate = data;
            });

            Bus.$on('selectedTemplateObjectEmitParent', data => {
                if(this.selectedTemplateObject.length > 0){
                    this.selectedTemplateObject.forEach(item => {
                        if(item.section_id == data.section_id && item.type == data.type){
                            item.template_id = data.template_id;
                            this.addedInSelectedTemplateObject = false;
                        }
                    });
                    if(this.addedInSelectedTemplateObject){
                        this.selectedTemplateObject.push(data);
                        $('#'+data.type+data.section_id).addClass('border-blue-lightest bg-blue-lightest');
                    }
                    this.addedInSelectedTemplateObject = true;
                }else{
                    this.selectedTemplateObject.push(data);
                    $('#'+data.type+data.section_id).addClass('border-blue-lightest bg-blue-lightest');
                }
                if(data.selectedValue){
                    this.currentlySelectedSection.proposal_template_id = data.selectedValue;
                }
            });

            Bus.$on('deselectedTemplateObjectEmit', data => {
                var i;
                for(i=0; i < this.selectedTemplateObject.length; i++){
                    if(this.selectedTemplateObject[i].section_id == data.section_id){
                        $('#'+this.selectedTemplateObject[i].type+this.selectedTemplateObject[i].section_id).removeClass('border-blue-lightest bg-blue-lightest');
                        this.selectedTemplateObject.splice(i,1);
                    }
                }
            });

            Bus.$on('selectCoverPageTemplateChild', data => {
                this.enableShowReviewButton();
                this.emptyProposalPath();
            });

            Bus.$on('delResourceFile', data => {
                this.deleteResourceFile(data);
            });

            if(this.proposalTypes.length > 0){
                this.proposalTypes.forEach(item => {
                    if(item.id == this.proposal.selected_proposal_type){
                        this.selectedProposalTypeName = item.name;
                        this.selectedProposalType = item;
                        // this.selectProposalType(item);
                    }
                });
            }

            Bus.$on('sectionProposalTemplateGroupChangedParent', data => {
                this.initTempProposal(data);
            });

            this.prizmEditorBaseURL = process.env.MIX_PRIZM_EDITOR_URL;
            let ScriptEditor = document.createElement("script");
            ScriptEditor.setAttribute("src", this.prizmEditorBaseURL+"interface.js");
            document.head.appendChild(ScriptEditor);

            this.prizmSheetBaseURL = process.env.MIX_PRIZM_SHEET_URL;
            let ScriptSheet = document.createElement("script");
            ScriptSheet.setAttribute("src", this.prizmSheetBaseURL+"clientControl/interface.js");
            document.head.appendChild(ScriptSheet);

            Bus.$on('changeReviewButtonPrizm', data => {
                console.log('changeReviewButtonPrizm');
                if(!this.tempProposal.signed_at && !this.tempProposal.locked){
                    this.showReviewButton = false;
                }else{
                    self.fireErrorToast('Proposal is locked');
                    return false;
                }
            });

            Bus.$on('sectionSaveStatus', data => {
                this.sectionSaveStatus[data.sectionUniqueId] = data.status;
                if(data.status == 'saved'){
                    $('#custom'+data.sectionUniqueId).removeClass('orange-border');
                }
            });

            $('#copy-signing-link').tooltip();
            this.getIPFromAmazon();

            if(this.proposal.all_sales_taxes){
                this.formattedSalesTax = this.proposal.all_sales_taxes.map(item => ({
                    value: item.id,
                    text: item.name
                }));
            }

            Bus.$on('updateSectionForHeaderFooterImageParent', data => {
                console.log('here');
               this.unlock('forFetchingLatestData');
            });

            this.getQuoteCommentTemplates();
            Bus.$on('fetchAllQuoteCommentTemplates', data => {
                console.log('------------------->');
                this.getQuoteCommentTemplates();
            });
        },
        methods   : {
            saveProposal() {
                this.editName = false;
                let self      = this;
                axios.put('/proposal/' + self.proposal.id + '/proposal-generator', self.tempProposal)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            Bus.$emit('color', self.tempProposal.color);
                            self.initTempProposal(response.data.proposal);
                            self.fireSuccessToast(response.data.message);
                            self.enableShowReviewButton();
                        } else {
                            self.initTempProposal(response.data.proposal);
                            self.fireErrorToast(response.data.message);
                        }
                    });
            },
            handleIncludeInReportChange(section) {
                section.include_in_report = section.include_in_report ? 0 : 1;
                let includeInReportForm   = new Form({
                    section: section,
                });
                let self                  = this;
                includeInReportForm.put('/proposal/' + this.tempProposal.id + '/include-in-report')
                    .then((response) => {
                        if (response.status === 'success') {
                            self.initTempProposal(response.proposal);
                            self.fireSuccessToast(response.message);
                            this.enableShowReviewButton();
                            this.emptyProposalPath();
                        } else {
                            self.initTempProposal(response.proposal);
                            self.fireErrorToast(response.message);
                        }
                    });
            },
            handleSectionOrderChange(event) {
                if (event.moved) {
                    let oldIndex                               = event.moved.oldIndex;
                    let newIndex                               = event.moved.newIndex;
                    this.tempProposal.sections[newIndex].order = newIndex;
                    if (newIndex < oldIndex) {
                        for (let i = newIndex + 1; i <= oldIndex; i++) {
                            this.tempProposal.sections[i].order++;
                        }
                    } else {
                        for (let i = oldIndex; i < newIndex; i++) {
                            this.tempProposal.sections[i].order--;
                        }
                    }

                    let moveForm = new Form({
                        sections: this.tempProposal.sections,
                    });
                    let self     = this;
                    moveForm.put('/proposal/' + this.tempProposal.id + '/moved')
                        .then((response) => {
                            if (response.status === 'success') {
                                self.initTempProposal(response.proposal);
                                self.fireSuccessToast(response.message);
                            } else {
                                self.initTempProposal(response.proposal);
                                self.fireErrorToast(response.message);
                            }
                        });
                }
            },
            initTempProposal(proposal) {
                this.tempProposal.id                  = proposal.id;
                this.tempProposal.name                = proposal.name;
                this.tempProposal.sections            = Object.values(proposal.sections);
                this.tempProposal.sent_for_signing_at = proposal.sent_for_signing_at;
                this.tempProposal.locked              = proposal.locked;
                this.tempProposal.signed_at           = proposal.signed_at;
                this.tempProposal.signed_by           = proposal.signed_by;
            },
            open(index) {
                this.currentlySelectedSection      = this.tempProposal.sections[index];
                this.currentlySelectedSectionIndex = index;
            },
            addCustomSection() {
                $('#add-custom-section-button').attr('disabled',true);
                this.customSectionForm.include_in_report = true;
                this.customSectionForm.order             = this.tempProposal.sections.length;
                this.customSectionForm.text              = null;
                this.customSectionForm.pdf_path          = null;
                var customSectionNumber = [];
                var customeSectionSplit = [];
                this.tempProposal.sections.forEach(item => {
                    if(item.name.match(/Custom Section/gi)){
                        customeSectionSplit = item.name.split(' ');
                        customSectionNumber.push(parseInt(customeSectionSplit[2]));
                    }
                });
                if(customSectionNumber.length > 0){
                    var largest = Math.max.apply(0, customSectionNumber);
                    this.customSectionForm.name  = 'Custom Section ' + (largest + 1);
                }else{
                    this.customSectionForm.name  = 'Custom Section 1';
                }

                let self = this;
                self.customSectionForm.post('/proposal/' + self.proposal.id + '/proposal-generator/custom/create')
                    .then((response) => {
                        if (response.status === 'success') {
                            self.fireSuccessToast(response.message);
                            self.currentlySelectedSection = response.section;
                            self.enableShowReviewButton();
                            $('#add-custom-section-button').attr('disabled',false);
                        } else {
                            self.fireErrorToast(response.message);
                            $('#add-custom-section-button').attr('disabled',false);
                        }
                        self.initTempProposal(response.proposal);
                        $('#add-custom-section-button').attr('disabled',false);
                    });
            },
            deleteCustomSection(section) {
                this.tempProposal.sections = this.tempProposal.sections.filter((_section) => {
                    return _section.tag !== section.tag;
                });

                if (this.currentlySelectedSectionIndex !== 0) {
                    this.currentlySelectedSectionIndex--;
                }
                this.currentlySelectedSection = this.tempProposal.sections[this.currentlySelectedSectionIndex];

                let self = this;
                axios.delete('/proposal/' + this.proposal.id + '/custom-section/' + section.id)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.initTempProposal(response.data.proposal);
                            self.fireSuccessToast(response.data.message);
                            self.enableShowReviewButton();
                        } else {
                            self.initTempProposal(response.data.proposal);
                            self.fireErrorToast(response.data.message);
                        }
                    });
            },
            saveSection(uri, type, form, showMessage = true) {
                var i;
                for(i=0; i < this.selectedTemplateObject.length; i++){
                    if(this.selectedTemplateObject[i].section_id == form.id){
                        $('#'+this.selectedTemplateObject[i].type+this.selectedTemplateObject[i].section_id).removeClass('border-blue-lightest bg-blue-lightest');
                        this.selectedTemplateObject.splice(i,1);
                    }
                }
                this.tempProposal.sections.forEach(item =>{
                    if(form.id == item.id){
                        form.order = item.order;
                        form.include_in_report = item.include_in_report;
                    }
                });
                let self = this;
                form.put('/proposal/' + self.proposal.id + '/proposal-generator/' + uri)
                    .then((response) => {
                        if (response.status === 'success') {
                            if(showMessage){
                                self.fireSuccessToast(response.message);
                                self.enableShowReviewButton();
                            }
                        } else {
                            if(showMessage){
                                self.fireErrorToast(response.message);
                            }
                        }

                        self.initTempProposal(response.proposal);
                        self.currentlySelectedSection = response.section;
                        $(() => $('[data-toggle="tooltip"]').tooltip());
                    });
            },
            introductionChanged(introduction, showMessage = true) {
                let temp = Object.assign(this.introductionForm, introduction);
                this.saveSection('introduction', 'introduction', temp, showMessage);
                this.enableShowReviewButton();
            },
            titleChanged(title) {
                let temp = Object.assign(this.titleForm, title);
                this.saveSection('title', 'title', temp);
                this.enableShowReviewButton();
            },
            inspectionChanged(inspection) {
                let temp = Object.assign(this.inspectionForm, inspection);
                this.saveSection('inspection', 'inspection', temp);
                this.enableShowReviewButton();
            },
            quoteDetailsChanged(quoteDetails) {
                let temp = Object.assign(this.quoteDetailsForm, quoteDetails);
                this.saveSection('quote-details', 'quote-details', temp);
                this.enableShowReviewButton();
            },
            authorizationChanged(authorization) {
                let temp = Object.assign(this.authorizationForm, authorization);
                this.saveSection('authorization', 'authorization', temp);
                this.enableShowReviewButton();
            },
            termsAndConditionsChanged(termsAndConditions, showMessage = true) {
                let temp = Object.assign(this.termsAndConditionsForm, termsAndConditions);
                this.saveSection('terms-and-conditions', 'terms-and-conditions', temp, showMessage);
                this.enableShowReviewButton();
            },
            customSectionChanged(customSection, showMessage = true) {
                let temp = Object.assign(this.customSectionForm, customSection);
                this.saveSection('custom/' + this.customSectionForm.id, 'custom', temp, showMessage);
                this.enableShowReviewButton();
            },
            fireSuccessToast(message) {
                const Toast = Swal.mixin({
                    toast            : true,
                    position         : 'top-end',
                    showConfirmButton: false,
                    timer            : 2000
                });

                Toast.fire({
                    type : 'success',
                    title: message,
                });
            },
            fireErrorToast(message) {
                const Toast = Swal.mixin({
                    toast            : true,
                    position         : 'top-end',
                    showConfirmButton: false,
                    timer            : 2000
                });

                Toast.fire({
                    type : 'error',
                    title: message,
                });
            },
            review() {
                let newwindow = window.open('/proposal/' + this.tempProposal.id + '/proposal-generator/review','_blank');
                if (window.focus) {
                    newwindow.focus()
                }
            },
            openSendForSigningModal() {
                this.showSendLoader = true;
                $('.proposal-check-signing-field').show();
                this.customSigns = [];
                axios.post(route('proposal.custom-signature.get-signatures'), {proposalId: this.tempProposal.id})
                    .then((response) => {
                        if(response.data.signs.length > 0){
                            response.data.signs.forEach(item => {
                                if(item.email && item.email !== null){
                                    console.log('in');
                                    this.customSigns.push(item);
                                }
                            });

                            // this.customSigns = response.data.signs.filter(x => x.name !== 'Contact Signature');
                            if(this.customSigns.length > 0){
                                $("#sendForCustomSigner").modal("show");
                            }else{
                                $("#sendForSigning").modal("show");
                            }
                        }else{
                            this.customSigns = [];
                            $("#sendForSigning").modal("show");
                        }
                        this.showSendLoader = false;
                        $('.proposal-check-signing-field').hide();
                    });

            },
            sendForSigning() {
                this.$nextTick(() => {
                    let self = this;
                    if(self.sendForSigningForm.emails.length > 0 || self.customSigns.length > 0) {
                        var data = {
                            'proposal':this.proposal,
                            'type': 'send',
                            'emails':self.sendForSigningForm.emails,
                            'signers': this.customSigns,
                            'proposalId':this.proposal.id,
                        }

                        axios.post('/proposal/' + self.proposal.id + '/proposal-generator/send-for-signing-email-edit', data)
                            .then((response) => {
                                if (response.data.status === 'success') {
                                    $("#sendForSigning").modal("hide");
                                    // self.fireSuccessToast(response.message);
                                    self.initTempProposal(response.data.proposal)
                                    window.location.href = "/proposal/"+this.proposal.id+"/proposal-generator/email-edit";
                                } else {
                                    self.fireErrorToast(response.data.message);
                                    self.initTempProposal(response.data.proposal);
                                }
                            });
                    }else{
                        self.fireErrorToast('Please add an email.');
                    }
                });
            },
            addEmailForSigning(newEmail) {
                var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
                if (newEmail.match(mailformat)) {
                    const tag = {
                        email: newEmail,
                    };
                    this.sendForSigningForm.emails.push(tag);
                } else {
                    this.fireErrorToast("You have entered an invalid email address!");
                }
            },
            unlock(message = null) {
                let self = this;
                axios.put('/proposal/' + this.tempProposal.id + '/unlock')
                    .then((response) => {
                        if (response.data.status === 'success') {
                            if(!message){
                                self.fireSuccessToast(response.data.message);
                            }
                            self.initTempProposal(response.data.proposal)
                        } else {
                            if(!message){
                                self.fireErrorToast(response.data.message);
                            }
                            self.initTempProposal(response.data.proposal);
                        }
                    });
            },
            lock() {
                let self = this;
                axios.put('/proposal/' + this.tempProposal.id + '/lock')
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.fireSuccessToast(response.data.message);
                            self.initTempProposal(response.data.proposal)
                        } else {
                            self.fireErrorToast(response.data.message);
                            self.initTempProposal(response.data.proposal);
                        }
                    });
            },
            deleteProposal() {
                let self = this;
                Swal.fire({
                    title             : "Are you sure?",
                    text              : "Once deleted, you will not be able to recover this proposal!",
                    icon              : "warning",
                    buttons           : true,
                    showCancelButton  : true,
                    confirmButtonColor: 'red',
                    confirmButtonText : 'I\'m sure!',
                    closeOnConfirm    : true,
                    closeOnCancel     : true,
                }).then(result => {
                    if (result.value) {
                        axios.delete(route('proposal.destroy', self.tempProposal.id))
                            .then((response) => {
                                if (response.data.status === 'success') {
                                    window.location = '/project/' + response.data.project_id + '/edit';
                                } else {
                                    self.initTempProposal(response.data.proposal);
                                    self.fireErrorToast(response.data.message);
                                }
                            });
                    }
                });
            },
            signatureFooter() {
                Bus.$emit('signature', !this.signature);
            },
            openSaveAsTemplateModal() {
                Bus.$emit('openSaveAsTemplateModal', {});
            },
            removeTemplate() {
                Bus.$emit('removeTemplate');
            },
            updateTemplate() {
                Bus.$emit('updateTemplate');
                this.enableShowReviewButton();
            },
            applyTemplate() {
                Bus.$emit('applyTemplate', this.selectedTemplate);
                this.enableShowReviewButton();
            },
            editSectionName(index) {
                let self                    = this;
                self.currentEditSectionName = index;
            },
            saveSectionName(section, name) {
                let self                    = this;
                self.currentEditSectionName = -1;

                axios.put(route('proposal-generator-section.update', this.tempProposal.id), {
                    name   : name,
                    section: section
                })
                    .then((response) => {
                        Bus.$emit('customSectionChangedName', name);
                        if (response.data.status === 'success') {
                            self.initTempProposal(response.data.proposal);
                            self.fireSuccessToast(response.data.message);
                            self.enableShowReviewButton();
                            Bus.$emit('saveNameFetchTemplatesParent', true);
                        } else {
                            self.initTempProposal(response.data.proposal);
                            self.fireErrorToast(response.data.message);
                        }
                    });
            },
            duplicateSection(section) {
                let self = this;
                axios.post(route('proposal-generator.section-duplicate', this.tempProposal.id), {section: section})
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.fireSuccessToast(response.data.message);
                            self.currentlySelectedSection = response.data.section;
                            self.enableShowReviewButton();
                        } else {
                            self.fireErrorToast(response.data.message);
                        }
                        self.initTempProposal(response.data.proposal);
                    });
            },
            deleteSection(section) {

                this.tempProposal.sections = this.tempProposal.sections.filter((_section) => {
                    return _section.tag !== section.tag;
                });

                let self = this;
                axios.post(route('proposal-generator.section-delete', this.tempProposal.id), {section: section})
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.initTempProposal(response.data.proposal);
                            self.fireSuccessToast(response.data.message);
                            self.enableShowReviewButton();
                            if (this.currentlySelectedSectionIndex > 0) {
                                this.currentlySelectedSectionIndex = this.currentlySelectedSectionIndex-1;
                                this.currentlySelectedSection = this.tempProposal.sections[this.currentlySelectedSectionIndex];
                            }else{
                                this.currentlySelectedSection = this.tempProposal.sections[0];
                            }
                        } else {
                            self.initTempProposal(response.data.proposal);
                            self.fireErrorToast(response.data.message);
                        }
                    });
            },
            showApplyButton(_selectedTemplate) {
                this.selectedTemplate = _selectedTemplate;
                this.selectedTemplateId = _selectedTemplate.id;
                this.applyTemplateButton = true;
                this.isTemplateApplied = false;
                if(this.currentlySelectedSection.proposal_template_id && (_selectedTemplate.id == this.currentlySelectedSection.proposal_template_id)) {
                    this.isTemplateApplied = true;
                }
            },
            hideApplyButton() {
                this.applyTemplateButton = false;
                this.isTemplateApplied = false;
                this.selectedTemplate = null;
                this.selectedTemplateId = null;
                Bus.$emit('applyTemplate', this.selectedTemplate);
            },
            customSectionType(id,sectionType){
                Bus.$emit('customSectionType-'+id, sectionType);
                if(sectionType == 'photo'){
                    this.tempProposal.sections.forEach(item => {
                       if(item.tag !== 'title' && item.id == id){
                           item.type_pdf           = false;
                           item.type_text          = false;
                           item.type_sheet         = false;
                           item.type_quote         = false;
                           item.type_photo         = true;
                       }
                    });
                }
                if(sectionType == 'quote'){
                    this.tempProposal.sections.forEach(item => {
                        if(item.tag !== 'title' && item.id == id){
                            item.type_pdf           = false;
                            item.type_text          = false;
                            item.type_sheet         = false;
                            item.type_photo         = false;
                            item.type_quote         = true;
                        }
                    });
                }
            },
            markCustomSection(id, mark){
                axios.post(route('proposal.update-custom-section-mark-standard', id), {id: id,mark:mark,proposal_id:this.proposal.id})
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.initTempProposal(response.data.proposal);
                            this.fireSuccessToast(response.data.message);
                            this.enableShowReviewButton();
                            Bus.$emit('sectionMarkedAsStandard', 1);
                        } else {
                            this.initTempProposal(response.data.proposal);
                            this.fireErrorToast(response.data.message);
                        }
                    });
            },
            saveProjectName(){
                axios.post(route('api.project.update-project-name'), {
                    project_name: this.tempProjectName,
                    project_id: this.proposal.project_id
                }).then((response) => {
                        if (response.status) {
                            this.editName = false;
                            this.fireSuccessToast(response.data.message);
                        } else {
                            this.editName = false;
                            this.fireErrorToast(response.data.message);
                        }
                    });
            },
            downloadProposalPDF(){
                axios.get('/proposal/download/pdf/'+this.tempProposal.id)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.fireSuccessToast(response.data.message);
                        } else {
                            this.fireErrorToast(response.data.message);
                        }
                    });
            },
            generateReview(){

                if(this.tempProposal.signed_at){
                    this.fireErrorToast(response.data.message);
                }
                var toastBit = 1;
                if(this.sectionSaveStatus.length > 0){
                    this.sectionSaveStatus.forEach((item,index) => {
                        console.log(item, index);
                        if(item == 'failed'){
                            toastBit = 2;

                            $('#custom'+index).addClass('orange-border');
                            return false;
                        }
                    });
                    if(toastBit == 2){
                        this.fireErrorToast('One of the section is not saved properly. Please save and try again.');
                        return false;
                    }
                }

                this.emptyProposalPath();
                $('.proposal-overlay').show();
                this.getProposalIssues();
                axios.get('/proposal/generate-review/pdf/'+this.tempProposal.id+'/'+this.proposal.only_office)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.fireSuccessToast(response.data.message);
                            this.enableReviewButton();
                        } else {
                            this.fireErrorToast(response.data.message);
                        }
                    });

            },
            enableReviewButton(){
                if(this.tempProposal.signed_at){
                    this.fireErrorToast(response.data.message);
                }else{
                    axios.get('/proposal/review/pdf/'+this.tempProposal.id)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                this.showReviewButton = true;
                                $('.proposal-overlay').hide();
                                this.fireSuccessToast(response.data.message);
                                this.review();
                            } else {
                                if(response.data.proposal.pg_issues){
                                    let issueMessage = JSON.parse(response.data.proposal.pg_issues);
                                    $('.proposal-overlay').hide();
                                    $('.proposal-overlay-document').hide();
                                    this.getToast(8000).fire({
                                        type: 'error',
                                        title: issueMessage.message
                                    });
                                    return false;
                                }else{
                                    setTimeout(() => {
                                        this.enableReviewButton();
                                    }, 1500);
                                }
                            }
                        });
                }

            },
            emptyProposalPath(){
                axios.get('/proposal/remove-path/pdf/'+this.tempProposal.id);
            },
            enableShowReviewButton(){
                if(!this.tempProposal.signed_at && !this.tempProposal.locked){
                    this.showReviewButton = false;
                    this.emptyProposalPath();
                }else{
                    this.fireErrorToast('Proposal already signed');
                }

            },
            generateProposalDocument(){
                axios.get('/proposal/generate/document/'+this.tempProposal.id)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.fireSuccessToast(response.data.message);
                            $('.proposal-overlay-document').show();
                            this.checkProposalDocument();
                        } else {
                            this.fireErrorToast(response.data.message);
                        }
                    });
            },
            checkProposalDocument(){
                axios.get('/proposal/check/document/'+this.tempProposal.id).then((response) => {
                    if(response.data.status === 'success'){
                        $('.proposal-overlay-document').hide();
                        this.downloadProposalDocument();
                    }else{
                        setTimeout(() => {
                            this.checkProposalDocument();
                        }, 1500);
                    }
                });
            },
            downloadProposalDocument(){
                let newwindow = window.open('/proposal/download/document/'+this.tempProposal.id,'_blank');
                if (window.focus) {
                    newwindow.focus()
                }
            },
            deleteResourceFile(resourceFile) {
                let self = this;
                Swal.fire({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this resource!",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'I\'m sure!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then((result) => {
                    if (result.value) {
                        axios.delete(route('api.resource-files-proposal.destroy', {resourceFile: resourceFile.token})).then(() => {
                            Bus.$emit('fetchLatestResourceFileCall','true');
                            if(resourceFile.url == this.selectedResourceFile){
                                this.selectedResourceFile ='';
                                Bus.$emit('removeSelectedCoverImageOnDeletion','true');
                            }
                        }).catch(error => {
                            if (error.response.status === 403 && this.project) {
                                self.flash('Files can only be deleted by users involved on the project, managers or above.', 'error');
                            } else if (error.response.status === 403) {
                                self.flash('Files can only be deleted by managers or above.', 'error');
                            }
                        });
                    }
                });
            },
            sendForViewing() {
                let self = this;

                    if(this.sendForSigningForm.emails.length > 0 || self.customSigns.length > 0) {
                        var data = {
                            'proposal': this.proposal,
                            'type': 'view',
                            'emails': self.sendForSigningForm.emails,
                            'signers': this.customSigns,
                        }
                        axios.post('/proposal/' + self.proposal.id + '/proposal-generator/send-for-signing-email-edit', data)
                            .then((response) => {
                                if (response.data.status === 'success') {
                                    $("#sendForSigning").modal("hide");
                                    // self.fireSuccessToast(response.message);
                                    self.initTempProposal(response.data.proposal)
                                    window.location.href = "/proposal/" + this.proposal.id + "/proposal-generator/email-edit";
                                } else {
                                    self.fireErrorToast(response.data.message);
                                    self.initTempProposal(response.data.proposal);
                                }
                            });
                    }else{
                        this.fireErrorToast('Please add an email.');
                    }
            },
            selectProposalType(proposalType){
                if(this.tempProposal.locked && !this.tempProposal.signed_at){
                    this.fireErrorToast('Proposal is locked.');
                    return false;
                }
                $('.proposal-overlay-applying-template').show();
                axios.post(route('api.proposal-type.apply'), {'id':proposalType.id, proposalId: this.proposal.id}).then(({data}) => {
                    if(data.status == "success"){
                        this.selectedProposalTypeName = proposalType.name;
                        if(this.toastMessage) {
                            this.fireSuccessToast(data.message);
                        }
                        this.initTempProposal(data.proposal)
                        this.enableShowReviewButton();
                        Bus.$emit('coverOptionsParent', data.coverPage);
                        Bus.$emit('refreshResourcesSideBarParent', true);
                        this.tempProposal.selected_proposal_type = proposalType.id;
                        this.proposalCoverPageOptions = data.coverPage;
                        this.selectedProposalType = proposalType;
                        if(data.coverPage.all_cover == 1){
                            this.open(1);
                        }else{
                            this.open(0);
                        }
                        $('.proposal-overlay-applying-template').hide();
                    }else{
                        this.fireErrorToast(data.message);
                    }

                    this.toastMessage = true;
                });
            },
            handler:function(section, index){
                var checkSection = this.checkTemporaryProposalTypeSection(section);
                if(checkSection){
                    this.open(index);
                }
            },
            checkTemporaryProposalTypeSection(section){
                if(section.tag == 'CustomSectionType'){
                    this.fireErrorToast('Please apply the proposal to edit its section.')
                    return false;
                }else{
                    return true;
                }

            },
            deselectProposalType(){
                if(this.tempProposal.locked && !this.tempProposal.signed_at){
                    this.fireErrorToast('Proposal is locked.');
                    return false;
                }
                this.selectedProposalTypeName = 'Proposal Templates';
                axios.post(route('api.proposal-type.deselect'), {proposalId: this.proposal.id}).then(({data}) => {
                    if(data.status == "success"){
                        this.fireSuccessToast(data.message);
                        this.initTempProposal(data.proposal)
                        this.enableShowReviewButton();
                        Bus.$emit('coverOptionsParent', data.coverPage);
                        this.tempProposal.selected_proposal_type = null;
                    }else{
                        this.fireErrorToast(data.message);
                    }

                });
            },
            makeCurrentProposalDefaultProposalType(proposalTypeId){
                axios.post(route('api.proposal-type.make-default'), {proposalId: this.proposal.id, proposalTypeId:proposalTypeId}).then(({data}) => {
                    if(data.status == "success"){
                        this.fireSuccessToast(data.message);
                        window.location.reload();
                    }else{
                        this.fireErrorToast(data.message);
                    }

                });
            },
            assignProposalTemplateGroup(){
                Bus.$emit('assignTemplateGroupParent', true);
            },
            unassignProposalTemplateGroup(section){
                axios.post(route('api.proposal-template-group.unselect-templates-group-for-proposal'), {section: section.id}).then(({data}) => {
                    if(data.status == "success"){
                        this.fireSuccessToast(data.message);
                        this.initTempProposal(data.proposal);
                        Bus.$emit('refetchTemplateWhenTemplateGroupUnassignedParent', true);
                    }else{
                        this.fireErrorToast(data.message);
                    }

                });
            },
            copyProposal(){
                let self = this;
                Swal.fire({
                    title: "Create a copy",
                    text: "You are going to create a copy of this proposal.",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Create Copy',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then((result) => {
                    if (result.value) {
                        $('.proposal-overlay-creating-copy').show();
                        axios.post(route('proposal.copy-proposal'), {proposalId: self.tempProposal.id}).then((response) => {
                            $('.proposal-overlay-creating-copy').hide();
                            self.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                        })
                    }
                });
            },
            copySigningLink(){
                let link = route('proposal.preview-for-signing', {
                    'proposal-token': this.proposal.token,
                    'signer-token': this.proposal.signer_token,
                });
                navigator.clipboard.writeText(link);
                this.getToast().fire({
                    type: 'success',
                    title: 'Proposal Signing Link Copied'
                });
                $('#sendForSigning').modal('hide');

                this.proposalData.userEmails = this.sendForSigningForm.emails;
                this.proposalData.sendType = 'copyLink';
                const proposal = {
                    proposal:this.proposalData,
                    senderIp: this.senderIp,
                    proposalId: this.proposal.id,
                    userTimeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    userTimeZoneOffset: new Date().getTimezoneOffset(),
                };
                axios.post('/proposal/' + this.proposalData.id + '/proposal-generator/send-for-signing', proposal);
            },
            getIPFromAmazon() {
                fetch('https://api.ipify.org?format=json')
                    .then(x => x.json())
                    .then(({ ip }) => {
                        this.senderIp = ip;
                    });
            },
            checkSigningFields(buttonFor = null){
                if(this.customSigns.length > 0){
                    if(buttonFor == 'sign'){
                        this.sendForSigning();
                    }else if(buttonFor == 'copy'){
                        this.copySigningLink();
                    }
                }else{
                    if(this.sendForSigningForm.emails.length > 0) {
                        $('#sendForSigning').modal('hide');
                        if(buttonFor == 'sign'){
                            this.sendForSigning();
                        }else if(buttonFor == 'copy'){
                            this.copySigningLink();
                        }
                    }else{
                        this.fireErrorToast('Please add an email.');
                    }
                }
            },
            getProposalIssues(){
                axios.post(route('proposal.get-proposal-issues'), {proposalId: this.tempProposal.id}).then((response) => {
                    if(response.data.proposal.pg_issues){
                        let issues = JSON.parse(response.data.proposal.pg_issues);
                        this.pgIssueMessage = issues.message;
                    }else{
						this.pgIssueMessage = null;
                    }
					setTimeout(() => {
						this.getProposalIssues();
					}, 5000);
                });
            },
            getQuoteCommentTemplates(){
                axios.post(route('proposal.quote-section.get-all-quote-comment-templates')).then(response => {
                    this.quoteCommentTemplates = response.data.allTemplates;
                    Bus.$emit('selectCommentTemplate', true);
                });
            },
            handlerSign:function(sign, index){
                // var checkSection = this.checkTemporaryProposalTypeSection(section);
                // if(checkSection){
                //     this.open(index);
                // }
            },
            handleSignOrderChange(event) {
                if (event.moved) {

                }
            },
        },
    }
</script>

<style lang="scss" escoped>
    .ql-editor {
        background-color: #fff;
        min-height: 191px;
    }

    .vue-swatches__trigger{
        width: 30px !important;
        height: 30px !important;
    }

    main.m-4{
        margin-top: 0 !important;
        padding-top: 1rem !important;
    }

    #proposalTopToolBar .btn{
        font-size:10px;
    }

    .proposal-select,
    .multiselect--acive{
        width: 95% !important;
    }

    .proposal-select *{
        font-size:10px !important;
    }

    .proposal-select .multiselect__select:before{
        top: 35% !important;
    }

    .proposal-select .multiselect__tags{
        min-height: 30px !important;
        padding: 5px 40px 0 8px !important;
    }

    .proposal-select .multiselect__single{
        font-size: 10px !important;
    }
    .template-dropdown-select .multiselect {
        width: 150px !important;
    }
    .template-dropdown-select .multiselect .multiselect__tags{
        overflow: hidden !important;
    }

    .template-dropdown-select .multiselect .multiselect__select,
    .template-dropdown-select .multiselect--active .multiselect__select{
        overflow: hidden !important;
        background: #fff;
        height: 3vh !important;
        top: 1px !important;
        z-index: 999 !important;
        padding-top: 15px !important;
        border-radius: 5px !important;
        padding-bottom:13px !important;
    }
    .project-title {
        width: 200px;
        overflow: hidden;
        height: 28px;
        font-size: 1.2rem;
        color: #333;
        top: -3px;
        position: relative;
    }
    .proposal-back-btn{
        font-size: 1.5rem;
        font-weight:200;
    }
    .proposal-back-btn:hover{
        text-decoration: none !important;
    }
    .project-title:first-child{
        margin-right: 10px;
    }
    .section-turned-off:hover {
        border-color: red;
        background-color: #e6e6e6;
    }
    .section-turned-off-active {
        border-color: red !important;
        background-color: #e6e6e6;
    }
    .section-title{
        width: 100%;
        height: 35px;
        overflow: hidden;
        font-size: 16px;
        padding: 7px 0;
    }
    .projectNameField{
        color:#333;
        border: none;
        background: none;
        box-shadow: unset;
        width: auto;
        margin: 0;
        padding: 0;
        height: 30px;
        top: -3px;
        position: relative;
        font-size: 20px;
    }
    .section-turned-off {
        background-color: #e6e6e6;
        border-color: #e6e6e6;
    }
    .proposal-overlay{
        position: fixed;
        display: none;
        width: 100%;
        height: 100%;
        top:18px;
        left: 0;
        right: 0;
        bottom: 0;
        //background-color: rgba(0,0,0,0.5);
        z-index: 999;
        cursor: pointer;
        background: #ffffffd9;
    }
    .proposal-overlay img{
        position: absolute;
        right: 42%;
        top: 28%;
    }
    .proposal-overlay h1{
        position: absolute;
        color: #01b1af;
        top: 60%;
        right: 30%;
        font-weight: 200;
    }
    .proposal-overlay-document{
        position: fixed;
        display: none;
        width: 100%;
        height: 100%;
        top:18px;
        left: 0;
        right: 0;
        bottom: 0;
        //background-color: rgba(0,0,0,0.5);
        z-index: 999;
        cursor: pointer;
        background: #ffffffd9;
    }
    .proposal-overlay-document img{
        position: absolute;
        right: 42%;
        top: 28%;
    }
    .proposal-overlay-document h1{
        position: absolute;
        color: #01b1af;
        top: 60%;
        right: 30%;
        font-weight: 200;
    }
    .deselect-proposal-type-name-span{
        color:red !important;
    }
    .section-name-div{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 155px;
        display: inline-block;
    }
    button#proposal-type-setting__BV_toggle_ {
        width: 500px !important;
    }
    span.proposal-type-head-span {
        display: block;
        overflow: hidden;
    }
    span.proposal-type-head-span li {
        width: 90%;
        float: left;
    }
    span.proposal-type-head-span button {
        width: 10%;
        padding: 10px;
    }
    span.proposal-type-head-span button:focus {
        border:none !important;
    }

    #proposal-template-settings-dropdown button:hover,
    #proposal-template-settings-dropdown button.dropdown-toggle,
    #proposal-template-settings-dropdown button.active,
    .show > .btn-outline-danger.dropdown-toggle {
        color: #01b1af !important;
        background-color: #ffffff !important;
        border-color: #ffffff !important;
    }

    button#proposal-template-settings-dropdown__BV_toggle_ {
        width: 250px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
    }

    button#proposal-template-settings-dropdown__BV_toggle_ {
        width: 100% !important;
        max-width: 100% !important;
    }

    div#proposal-template-settings-dropdown {
        width: 100%;
    }
    .orange-border{
        border: 2px solid orange !important;
    }
    .proposal-overlay-applying-template h1{
        right: 40%;
    }
    .proposal-overlay-creating-copy h1{
        right: 38%;
    }

    .pg-loader {
        position: absolute;
        right: 24vw !important;
        top: 55% !important;
        width: 50vw !important;
    }

    #sendForSigning .btn-outline-primary:disabled {
        color: #525050;
        border-color: #525050;
    }

    //nav.navbar.navbar-dark.navbar-expand-md.navbar-spark.bg-followup-nav.shadow-md.sticky-top {
    //    z-index: 9999 !important;
    //}
    //
    //.swal2-container {
    //    z-index: 99999 !important
    //}
</style>

